<esn-background-glow class="esn-app-error">
  <div class="esn-app-error__stage">
    <esn-empty-state class="esn-app-error__panel" [title]="title()" [text]="message()">
      @if (detail(); as text) {
        <details class="esn-app-error__details">
          <summary>{{ detailsLabel() }}</summary>
          <pre>{{ text }}</pre>
        </details>
      }
      <esn-button (clicked)="retry.emit()">{{ retryLabel() }}</esn-button>
    </esn-empty-state>
  </div>
</esn-background-glow>
